import { logout } from '../../auth.service';
import Login from '../../../pages/Login';

const FranquiaD = () =>
{    
    localStorage.setItem("tenantId", "franquiad");
    localStorage.setItem("logoVertical", "logoSampleclient");
    logout();
    
    return Login();
};

export default FranquiaD;